// log the pageview with their URL
export const pageview = (url) => {
  // No-op during server-side rendering, where there is no window.
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "undefined") {
    window.gtag("config", process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS, {
      page_path: url,
    });
  } else {
    console.log("gtag not defined");
  }
};

// log specific events happening.
export const event = ({ action, params }) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, params);
  } else {
    console.log("gtag not defined");
  }
};
